import { encodeParameters } from "Api/utils";

export const getDeploymentSettingsUrl = ({
  projectId,
  environmentId
}: {
  projectId: string;
  environmentId: string;
}) => {
  const { projectId: encodedProjectId, environmentId: encodedEnvironmentId } =
    encodeParameters({ projectId, environmentId });

  return `/projects/${encodedProjectId}/environments/${encodedEnvironmentId}/settings`;
};
export const getDeploymentNextUrl = ({
  projectId,
  environmentId,
  verbose
}: {
  projectId: string;
  environmentId: string;
  verbose?: boolean;
}) => {
  const { projectId: encodedProjectId, environmentId: encodedEnvironmentId } =
    encodeParameters({ projectId, environmentId });
  const verboseQueryParam = verbose ? `?verbose=true` : "";

  return `/projects/${encodedProjectId}/environments/${encodedEnvironmentId}/deployments/next${verboseQueryParam}`;
};
